'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n  padding: ', ';\n  vertical-align: middle;\n  width: 100%;\n  margin-bottom: ', ';\n\n  /* Hide base elements */\n  input[type="checkbox"] {\n    position: absolute;\n    left: -9999px;\n  }\n\n  /* Position the <label> */\n  input[type="checkbox"] + label {\n    position: relative;\n    display: inline-block;\n    height: 17px;\n    line-height: 17px;\n    padding-left: 30px;\n    cursor: pointer;\n  }\n\n  /* SHARED STYLES - Radio & Checkbox - Unchecked */\n  input[type="checkbox"] + label:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 18px;\n    height: 18px;\n    border: 2px solid ', ';\n    background-color: ', ';\n  }\n\n  /* CHECKBOX - Unchecked */\n  input[type="checkbox"]:not(:checked) + label:before {\n    /* Add styles if needed */\n  }\n\n  /* CHECKBOX - Checked ( CSS Tick ) */\n  input[type="checkbox"]:checked + label:after {\n    position: absolute;\n    content: "";\n    left: 7px;\n    top: 0px;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    /* Short Arm */\n    width: 5px;\n    border-bottom: 3px solid ', ';\n    /* Long Arm */\n    height: 11px;\n    border-right: 3px solid ', ';\n  }\n\n  /* SHARED STYLES - Radio & Checkbox - Disabled */\n  input[type="checkbox"]:disabled + label:before {\n    border-color: #bbb;\n    background-color: #ddd;\n  }\n\n  input[type="checkbox"]:disabled + label {\n    color: #999;\n  }\n'], ['\n  height: ', ';\n  padding: ', ';\n  vertical-align: middle;\n  width: 100%;\n  margin-bottom: ', ';\n\n  /* Hide base elements */\n  input[type="checkbox"] {\n    position: absolute;\n    left: -9999px;\n  }\n\n  /* Position the <label> */\n  input[type="checkbox"] + label {\n    position: relative;\n    display: inline-block;\n    height: 17px;\n    line-height: 17px;\n    padding-left: 30px;\n    cursor: pointer;\n  }\n\n  /* SHARED STYLES - Radio & Checkbox - Unchecked */\n  input[type="checkbox"] + label:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 18px;\n    height: 18px;\n    border: 2px solid ', ';\n    background-color: ', ';\n  }\n\n  /* CHECKBOX - Unchecked */\n  input[type="checkbox"]:not(:checked) + label:before {\n    /* Add styles if needed */\n  }\n\n  /* CHECKBOX - Checked ( CSS Tick ) */\n  input[type="checkbox"]:checked + label:after {\n    position: absolute;\n    content: "";\n    left: 7px;\n    top: 0px;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    /* Short Arm */\n    width: 5px;\n    border-bottom: 3px solid ', ';\n    /* Long Arm */\n    height: 11px;\n    border-right: 3px solid ', ';\n  }\n\n  /* SHARED STYLES - Radio & Checkbox - Disabled */\n  input[type="checkbox"]:disabled + label:before {\n    border-color: #bbb;\n    background-color: #ddd;\n  }\n\n  input[type="checkbox"]:disabled + label {\n    color: #999;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* https://codepen.io/rafacdb/pen/jwRWmM */


var CheckboxStyled = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.bahFormInputDefaultHeight;
}, function (props) {
  return props.theme.bahFormInputRadioCheckDefaultPadding;
}, function (props) {
  return props.theme.bahFormFieldsDefaultMarginBottom;
}, function (props) {
  return props.theme.bahFormInputBorderColor;
}, function (props) {
  return props.theme.bahFormInputBackgroundColor;
}, function (props) {
  return props.theme.bahFormInputBorderColor;
}, function (props) {
  return props.theme.bahFormInputBorderColor;
});

var Checkbox = function Checkbox(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      name = _ref.name,
      id = _ref.id;
  return _react2.default.createElement(
    CheckboxStyled,
    null,
    _react2.default.createElement('input', { type: 'checkbox', disabled: disabled, name: name, id: id }),
    _react2.default.createElement(
      'label',
      { htmlFor: id },
      children
    )
  );
};

Checkbox.defaultProps = {
  children: '',
  name: '',
  id: '',
  disabled: false
};

Checkbox.propTypes = {
  children: _propTypes2.default.string,
  name: _propTypes2.default.string,
  id: _propTypes2.default.string,
  disabled: _propTypes2.default.bool
};

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/Checkbox.js
// module id = 101
// module chunks = 0